{
  "changedSuccessfully": "Salasana vaihdettu onnistuneesti!",
  "setPasswordText": "Syötä haluamasi uusi salasana",
  "passwordChangeFailedText": "Salasanan vaihto epäonnistui",
  "errorCauses": {
    "wrongCode": "virheellinen vahvistuskoodi",
    "expiredCode": "vahvistuskoodi vanhentunut",
    "wrongPassword": "salasana ei täytä vaatimuksia",
    "tooManyAttempts": "liian monta yritystä",
    "userNotConfirmed": "käyttäjän sähköpostiosoitetta ei ole vahvistettu",
    "userNotFound": "käyttäjää ei löytynyt"
  },
  "passwordForgottenHeader": "Salasana unohtunut",
  "resetCodeSent": "Salasanan vaihtoon tarvittava vahvistuskoodi on lähetetty sähköpostiisi",
  "resetCodeSent2": "Jos et saanut sähköpostia, tarkista roskapostikansio",
  "resetCodeInputLabel": "Vahvistuskoodi",
  "resetCodeSubmitButtonText": "Siirry vaihtamaan salasana",
  "forgotPasswordViewInputEmailDescription": "Syötä asukassivuilla käyttämäsi sähköpostiosoite.",
  "sendForgotPasswordEmailButtonText": "Lähetä pyyntö",
  "resetUser": {
    "text": "Mikäli et muista tunnusta, jolla olet rekisteröitynyt käyttäjäksi, voit rekisteröityä uudelleen",
    "resetLinkText": "tästä"
  }
}
